import { getPageType } from '~/events/utils/pageType'
import productTransformer from './transformers/product.transformer'

export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.PRODUCT.PAGE_VIEW, ({ product, variant, colour = null, price = 0, priceVat = 0 }) => {
    const transformedProduct = productTransformer(product, 1, price, priceVat, 0, null, colour)

    if (!transformedProduct) {
      return
    }

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'CZK',
        value: transformedProduct.price,
        value_vat: transformedProduct.price_vat,
        mkt_val_all: transformedProduct.mkt_val,
        items: [transformedProduct],
        google_tag_params: {
          ecomm_pagetype: getPageType(),
          ecomm_prodid: [String(transformedProduct.item_id)],
          ecomm_totalvalue: transformedProduct.price,
          ecomm_totalvalue_all: [transformedProduct.price],
        },
      },
    })
  })
}
